import React from "react";
import room from "../images/classroom.jpeg";
import courses from "../courses";
function Course(){
    return (
        <div className="flex flex-col pt-5 p-6 md:p-10 lg:p-16 mb-20" style={{backgroundImage:`url(${room})`}}>
            <div className="flex text-3xl md:text-4xl lg:text-5xl justify-center p-8 md:p-10">
                <h2 className="flex uppercase font-normal text-white">Courses Offered</h2>
            </div>
            <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-10">
                {
                    courses.map((course,index) => {
                        return (
                            <div key={index} className="flex flex-col gap-1 bg-white rounded-xl w-full text-justify translate-y-2 hover:translate-y-0 transition-all ease-in-out duration-300">
                                <img className="flex w-full h-auto rounded-xl" src={course.img} alt="" srcset="" />
                                <h2 className="flex justify-center text-xl md:text-2xl">{course.title}</h2>
                                <p className="flex flex-col text-md md:text-lg pt-0 p-3 ">{course.desc}</p>
                                <hr className="flex w-11/12 mx-auto" />
                                <a href={course.link} className="flex text-md p-4">More Details</a>
                            </div>   
                        )
                    })
                }
            </div>
        </div>
    );
}

export default Course;